import ApiService from "@/services/api.service";
export default async function getAllObjectTypes() {
  const response = await ApiService.get("enum/objectType/list");
  return response.data;
}
